import { mdiCog } from '@mdi/js';
import Icon from '@mdi/react';
import React from 'react';
import PropTypes from 'prop-types';
import useQueryParams from 'hooks/useQueryParams';
import { Button, Tooltip } from 'antd';
import Ninja from '@ninja';
import DeleteReceivedPostback from '../components/DeleteReceivedPostback';

const PostbackActionFormatter = ({ row, disableDeleteAction = false, ids }) => {
  const { setUrlParams } = useQueryParams();

  return (
    <>
      <Tooltip title='Config'>
        <Button
          onClick={() => setUrlParams({ edit: true, postback_id: row?.id || ids })}
          icon={<Icon color={Ninja.colors.light} path={mdiCog} />}
          type='text'
          size='small'
          shape='circle'
        />
      </Tooltip>
      {!disableDeleteAction && <DeleteReceivedPostback id={row.id} />}
    </>
  );
};

PostbackActionFormatter.propTypes = {
  row: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string,
  }).isRequired,
};

export default PostbackActionFormatter;
